export default {
    currencyId: state => {
        return state.currencyId;
    },
    taxRateForDoctors: state => {
        return state.taxRateForDoctors;
    },
    taxRateForHospital: state => {
        return state.taxRateForHospital;
    },
    configsToEdit: state => {
        return state.configsToEdit;
    },
    accounting: state => {
        return state.accounting;
    },
}
